import { Component, OnInit } from '@angular/core';
import { Validators } from '@angular/forms';
import { FieldType } from '@ngx-formly/core';

@Component({
  selector: 'date-picker-formly',
  templateUrl: './date-picker-formly.component.html',
  styleUrls: ['./date-picker-formly.component.scss'],
})
export class DatePickerFormlyComponent extends FieldType implements OnInit {

  ngOnInit(): void {
    if (this.props.required) {
      this.formControl.addValidators(Validators.required);
    }
  }

}
